import { render, staticRenderFns } from "./AddPoint.vue?vue&type=template&id=12bc149f&scoped=true"
import script from "./AddPoint.vue?vue&type=script&lang=js"
export * from "./AddPoint.vue?vue&type=script&lang=js"
import style0 from "./AddPoint.vue?vue&type=style&index=0&id=12bc149f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12bc149f",
  null
  
)

export default component.exports